module.exports = __webpack_public_path__ + "img/About_b2.201a10fe.png";